module.exports = {
    footerText: 'Copyright © ' + new Date().getFullYear() + ' - Phillips Outsourcing Services Nigeria Limited',
}
